<template>
  <v-dialog
    v-model="dialog"
    width="500"
    persistent
    @keydown.esc="dialog = false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        rounded
        depressed
        small
        v-bind="attrs"
        v-on="on"
      >
        {{ $t("changeBuyer.change") }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-row no-gutters align="center">
          <span>{{ $t("changeBuyer.changeBuyer") }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-row>
      </v-card-title>

      <v-card-text class="mt-2">
        <span>
          {{ $t("changeBuyer.textOne") }}
        </span>
        <br />
        <br />
        <span>
          {{ $t("changeBuyer.textTwo") }}
        </span>
      </v-card-text>

      <v-card-actions>
        <v-row class="pb-4" no-gutters justify="center">
          <v-btn
            outlined
            rounded
            color="red"
            height="40"
            @click="handleLogout"
            >{{ $t("changeBuyer.logout") }}</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    handleLogout() {
      localStorage.removeItem("loggedUser");
      this.$store.commit("SET_LOGGED_USER", null);
      this.$store.dispatch("setPaymentOption", null);
      this.dialog = false;
    },
  },
};
</script>
